import { render, staticRenderFns } from "./OnboardingStep.vue?vue&type=template&id=13531d2d&"
import script from "./OnboardingStep.vue?vue&type=script&lang=ts&"
export * from "./OnboardingStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports